export const DEFAULT_FILE_MODEL = {
  name: '',
  data: '',
  isReady: false,
  hasError: false,
  isDisabled: true,
};
